import { useSlotDialogParam } from "hooks/useSlotDialogParam";
import { useLocation, useNavigate } from "react-router-dom";

export const useCloseDialog = (saveHistory: boolean) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [, setSlotIdParam] = useSlotDialogParam();

  return async () => {
    await setSlotIdParam(null);

    // Don't open the previous slot dialog when coming back to calendar page
    if (location.pathname === "/" && !saveHistory) {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.delete("slotId");
      const cleanSearch = searchParams.toString();
      navigate(
        { pathname: "/", search: cleanSearch ? `?${cleanSearch}` : "" },
        { replace: true },
      );
    }
  };
};
